import * as ActionTypes from '../constants/actionTypes'
import { sellerCreate, sellerRead, sellerUpdate, sellerDelete, sellerCreateEPO } from '../api/seller'

export const editForm = formFieldsChange => ({
  type: ActionTypes.SELLERFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.SELLERFORM_ENTER_RESET,
})

export const fetchItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERFORM_FETCHITEM_LOAD })

  sellerRead(values).then((res) => {
    const item = res.result
    const promptClient = !!item.s_ai_json ? !!JSON.parse(item.s_ai_json).find(prompt => prompt.f_prompt_type === 1) ? JSON.parse(item.s_ai_json).find(prompt => prompt.f_prompt_type === 1).s_prompt : "" : ""
    const promptSeller = !!item.s_ai_json ? !!JSON.parse(item.s_ai_json).find(prompt => prompt.f_prompt_type === 2) ? JSON.parse(item.s_ai_json).find(prompt => prompt.f_prompt_type === 2).s_prompt : "" : ""
    const promptFeedback = !!item.s_ai_json ? !!JSON.parse(item.s_ai_json).find(prompt => prompt.f_prompt_type === 3) ? JSON.parse(item.s_ai_json).find(prompt => prompt.f_prompt_type === 3).s_prompt : "" : ""
    const promptNIOKR = !!item.s_ai_json ? !!JSON.parse(item.s_ai_json).find(prompt => prompt.f_prompt_type === 4) ? JSON.parse(item.s_ai_json).find(prompt => prompt.f_prompt_type === 4).s_prompt : "" : ""
    const promptNegativeRating = !!item.s_ai_json ? !!JSON.parse(item.s_ai_json).find(prompt => prompt.f_prompt_type === 5) ? JSON.parse(item.s_ai_json).find(prompt => prompt.f_prompt_type === 5).s_prompt : "" : ""

    dispatch({
      type: ActionTypes.SELLERFORM_FETCHITEM_SUCCEED,
      item,
    })
    dispatch({
      type: ActionTypes.SELLERFORM_EDITFORM_CHANGE,
      field: {
        id: { name: 'idnum', value: item.idnum },
        s_name: { name: 's_name', value: item.s_name },
        s_feedback: { name: 's_feedback', value: item.s_feedback },
        s_address: { name: 's_address', value: item.s_address },
        s_phone: { name: 's_phone', value: { number: item.s_phone, prefix: item.s_phone_prefix, country: {} } },
        s_available_prefixes: { name: 's_available_prefixes', value: JSON.parse(item.s_available_prefixes) },
        s_site: { name: 's_site', value: item.s_site },
        s_chatbot_token: { name: 's_chatbot_token', value: item.s_chatbot_token },
        n_bonus_percent: { name: 'n_bonus_percent', value: item.n_paybonus },
        n_disable: { name: 'n_disable', value: item.n_disable === '1' },
        n_disable_billing: { name: 'n_disable_billing', value: item.n_disable_billing === '1' },
        is_enable_sms: { name: 'is_enable_sms', value: item.is_enable_sms === '1' },
        n_mts_env: { name: 'n_mts_env', value: item.n_mts_env === '1' },
        s_mts_token: { name: 's_mts_token', value: item.s_mts_token },
        s_token: { name: 's_token', value: item.s_token },
        f_kassa_type: { name: 'f_kassa_type', value: Number(item.f_kassa_type) },
        n_processing_type: { name: 'n_processing_type', value: Number(item.n_processing_type) },
        f_currency_type: { name: 'f_currency_type', value: Number(item.f_currency_type) },
        n_mts_exchange_minutes: { name: 'n_mts_exchange_minutes', value: item.n_mts_exchange_minutes },
        n_transfer: { name: 'n_transfer', value: item.n_transfer === '1' },
        n_cardsupport: { name: 'n_cardsupport', value: item.n_cardsupport === '1' },
        n_balance_limit: { name: 'n_balance_limit', value: item.n_balance_limit },
        n_convertation_coef: { name: 'n_convertation_coef', value: item.n_convertation_coef },
        n_promocode: { name: 'n_promocode', value: item.n_promocode === '1' },
        n_referral_link: { name: 'n_referral_link', value: item.n_referral_link === '1' },
        s_prompt_client: { name: 's_prompt_client', value: promptClient },
        s_prompt_seller: { name: 's_prompt_seller', value: promptSeller },
        s_prompt_feedback: { name: 's_prompt_feedback', value: promptFeedback },
        s_prompt_niokr: { name: 's_prompt_niokr', value: promptNIOKR },
        s_prompt_negative_rating: { name: 's_prompt_negative_rating', value: promptNegativeRating },
      },
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERFORM_FETCHITEM_FAIL,
      fetchItemError: 'Ошибка получения данных по торговой сети.',
    })
  })
}

export const createItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERFORM_CREATEITEM_LOAD })
  sellerCreate(values).then(() => {
    dispatch({ type: ActionTypes.SELLERLIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.SELLERFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.SELLERFORM_ENTER_RESET })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERFORM_CREATEITEM_FAIL,
      createItemError: 'Ошибка создания торговой сети.',
    })
  })
}

export const editItem = params => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERFORM_EDITITEM_LOAD })
  sellerUpdate(params).then(() => {
    dispatch({ type: ActionTypes.SELLERFORM_EDITITEM_SUCCEED })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERFORM_EDITITEM_FAIL,
      editItemError: 'Ошибка изменения данных.',
    })
  })
}

export const deleteItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERFORM_DELETEITEM_LOAD })

  sellerDelete(values).then(() => {
    dispatch({ type: ActionTypes.SELLERFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.SELLERFORM_ENTER_RESET })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERFORM_DELETEITEM_FAIL,
      deleteItemError: 'Ошибка удаления торговой сети.',
    })
  })
}

export const createItemEPO = values => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERFORM_CREATEITEM_LOAD })
  sellerCreateEPO(values).then(() => {
    dispatch({ type: ActionTypes.SELLERLIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.SELLERFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.SELLERFORM_ENTER_RESET })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERFORM_CREATEITEM_FAIL,
      createItemError: 'Ошибка создания торговой сети.',
    })
  })
}



// WEBPACK FOOTER //
// src/actions/sellerForm.js